import { SxProps, Theme } from "@mui/material";

export const oneWayStyles: (theme: Theme) => SxProps = (theme) => ({
  width: "100%",
  "& .rdp": {
    padding: 0,
    margin: {
      xs: 0,
      sm: 2,
    },
  },
  "& .rdp-table": {
    width: "100%",
    maxWidth: "initial",
    borderStyle: "0",
    tableLayout: "fixed",
  },

  "& .rdp-button.rdp-day": {
    height: theme.spacing(10),
    width: "100%",
    maxWidth: "initial",
    borderRadius: 0,
    borderWidth: "0!important",
  },
});
